import React, {Component} from 'react';

import {
    BrowserRouter as Router,
    Route,
    Switch
  } from 'react-router-dom'
import LoginForm from '../modules/login/templates/LoginForm';
import Pages from '../modules/Tabs/templates/Pages';
import {Cms, withPermissionControl} from './cms';
import {USER_ROLES} from './constants';

export default class Routes extends Component {
    render() {
        return(
            <Router>
                <Switch>
                    <Route path='/login' component={withPermissionControl(LoginForm, {
                        allowUnauthorized: true,
                        home: '/order'
                    })}/>
                    <Route path='/orders' component={withPermissionControl(Pages, {
                        allowAuthorized:true,
                        home: '/order',
                        allowedRoles:[
                            USER_ROLES.MANAGER,
                            USER_ROLES.ADMIN,
                            USER_ROLES.ORDER_MANAGER,
                            USER_ROLES.CALL_CENTER,
                            USER_ROLES.ACCOUNTANT,
                            USER_ROLES.PARTNER_MANAGER,
                            USER_ROLES.SUPER_ADMIN
                        ]})} />
                    <Route path='/' component={Cms} />
                </Switch>
            </Router>
        );
    }
};
